import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation upsertOperator($data: updateUserInput!, $id: String!) {
    upsertOperator(data: $data, id: $id) {
      status
      id
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const upsertOperatorRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.UpdateUserInput;id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/upsert_operator',
  async (
  params: {data: TYPES.UpdateUserInput;id: String;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.upsertOperator;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const upsertOperatorSlice = createSlice({
  name: 'upsert_operator',
  initialState: initialState,
  reducers: {
    upsertOperatorClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(upsertOperatorRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(upsertOperatorRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(upsertOperatorRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { upsertOperatorClear } = upsertOperatorSlice.actions;

export const upsertOperator = createSelector(
  (state: RootState) => state.user.upsertOperator.result,
  (state: RootState) => state.user.upsertOperator.error,
  (state: RootState) => state.user.upsertOperator.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default upsertOperatorSlice.reducer;